import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { collectedDataReducerEm, EmStateEffect, IAppStateEm } from '@theia-cc/em/state';
import { reduceReducers } from '@theia-cc/shared/helpers';
import { leadMetaReducer, ReducerRegistry, userInfoReducer } from '@theia-cc/shared/store';
import { ShareOfferPreviewResolver } from '../core/share-offer-preview.resolver';
import { INITIAL_STATE } from '../store/state';
import { StepsRoutingModule } from './steps-routing.module';
import { StepsComponent } from './steps.component';

export const StepsReducer = {
  collectedData: reduceReducers(
    INITIAL_STATE.collectedData,
    collectedDataReducerEm,
    userInfoReducer,
    leadMetaReducer
  ),
};

@NgModule({
  imports: [CommonModule, StepsRoutingModule],
  declarations: [StepsComponent],
  providers: [EmStateEffect, ShareOfferPreviewResolver],
})
export class StepsModule {
  constructor(private reducerRegistry: ReducerRegistry<IAppStateEm>) {
    this.reducerRegistry.registerReducers(StepsReducer);
  }
}
